import { Snackbar } from "@mui/material";
import { SnackbarProps } from "@mui/material/Snackbar";
import MuiSnackbarContent, { MuiSnackbarVariant } from "components/MuiExtras/Snackbar/MuiSnackbarContent";
import * as React from "react";

interface IProps {
    variant: MuiSnackbarVariant;
    onClose?: (event: React.SyntheticEvent | React.MouseEvent, reason?: string) => void;
};

type Props = IProps & SnackbarProps;

const r = React.createRef<HTMLDivElement>();

const MuiSnackbar: React.FC<Props> = (props) => {
    const { message, variant, onClose, ...rest } = props;
    return (
        <Snackbar
            {...rest}
            onClose={onClose}
        >
            <MuiSnackbarContent
                onClose={onClose}
                variant={variant}
                message={message}
            />
        </Snackbar>
    );
};

MuiSnackbar.defaultProps = {
    variant: "info",
};

export default MuiSnackbar;
